export default __webpack_public_path__ + "static/financial-freedom-light-0641cb76d141376ec7b2203cf56e62cf.svg";